import React from 'react';
import { WDHLocationsSpot, ListPaginated, GoogleMap, Search, FilterList } from '@demant/locations-spot';
import FilterListItemRadio from './views/filter-list-item';
import LocationDetail from './views/location-detail'; // eslint-disable-next-line no-unused-vars

import GTMTracking from './utils/gtm-tracking';
var locationsSpot = new WDHLocationsSpot();
locationsSpot.shouldReSortListOnSearch = true;
locationsSpot.useClustering = false;

locationsSpot.preProcessLocation = function (location) {
  location.UniqueId = "".concat(location.UniqueId).concat(location.Group);
  return location;
}; // DESKTOP LAYOUT


locationsSpot.addDesktopView( /*#__PURE__*/React.createElement(ListPaginated, {
  key: "list",
  header: [/*#__PURE__*/React.createElement(FilterList, {
    key: "filterList",
    filterListItemView: FilterListItemRadio
  }), /*#__PURE__*/React.createElement(Search, {
    key: "search"
  })],
  locationsStateHash: "temp",
  listDetailView: LocationDetail
}));
locationsSpot.addDesktopView( /*#__PURE__*/React.createElement(GoogleMap, {
  key: "map"
})); // MOBILE LAYOUT

locationsSpot.addMobileView( /*#__PURE__*/React.createElement(FilterList, {
  key: "filterList",
  filterListItemView: FilterListItemRadio
}));
locationsSpot.addMobileView( /*#__PURE__*/React.createElement(Search, {
  key: "search"
}));
locationsSpot.addMobileView( /*#__PURE__*/React.createElement(GoogleMap, {
  key: "map"
}));
locationsSpot.addMobileView( /*#__PURE__*/React.createElement(ListPaginated, {
  key: "list",
  locationsStateHash: "temp",
  listDetailView: LocationDetail
}));
locationsSpot.run();